import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'out-dealers',
  imports: [RouterLink],
  templateUrl: './dealers.component.html',
  styleUrl: './dealers.component.css',
})
export class DealersComponent implements OnInit {
  constructor(private meta: Meta, private titleService: Title) {}

  ngOnInit() {
    this.setMetaData();
  }

  setMetaData() {
    this.titleService.setTitle(
      'Join ONLY USED TESLA Dealer Network - Amplify Your Tesla Inventory Exposure | Only Used Tesla'
    );
    this.meta.addTags([
      {
        name: 'description',
        property: 'description',
        content:
          "Become a part of ONLY USED TESLA's exclusive dealer network.Expand your reach, increase sales, and accelerate your business growth.Discover the advantages of our targeted Tesla- specific advertising platform today.",
        vmid: 'description',
      },
    ]);
  }
}
